import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import swal from 'sweetalert2';

const EditRawMaterialSubCat = ({ show, onClose, subCategory, onUpdated }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategoryName, setSubcategoryName] = useState('');
  const [description, setDescription] = useState('');

  // ✅ Fetch all active categories
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${baseURL}/list/active`);
      const options = res.data.map(cat => ({
        value: cat.sno,
        label: cat.rawmaterialcategory_name,
      }));
      setCategories(options);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  // ✅ Fetch subcategory details when modal opens
  const fetchSubcategoryDetails = async () => {
    if (!subCategory?.sno) return;
    setLoading(true);
    try {
      const res = await axios.get(`${baseURL}/rawmaterial-sub/show/${subCategory.sno}`);
      if (res.data.success) {
        const sub = res.data.data;
        setSubcategoryName(sub.subcategory_name);
        setDescription(sub.description || '');
        if (sub.rawmaterial_category_details) {
          setSelectedCategory({
            value: sub.rawmaterial_category_details.sno,
            label: sub.rawmaterial_category_details.rawmaterialcategory_name,
          });
        }
      }
    } catch (error) {
      console.error('Error fetching subcategory details:', error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle update
  const handleUpdate = async () => {
    if (!selectedCategory || !subcategoryName.trim()) {
      swal.fire('Missing Fields', 'Please fill all required fields.', 'warning');
      return;
    }

    const payload = {
      subcategory_name: subcategoryName,
      rawmaterial_category_sno: selectedCategory.value,
      description,
    };

    try {
      const res = await axios.post(`${baseURL}/rawmaterial-sub/update/${subCategory.sno}`, payload);
      if (res.data.success) {
        swal.fire({
          title: 'Updated!',
          text: 'Raw Material Sub Category updated successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        if (onUpdated) onUpdated();
        onClose();
      }
    } catch (error) {
      console.error('Error updating subcategory:', error);
      swal.fire('Error', 'Failed to update subcategory.', 'error');
    }
  };

  // Load category list and subcategory data
  useEffect(() => {
    if (show) {
      fetchCategories();
      fetchSubcategoryDetails();
    }
  }, [show, subCategory]);

  return (
    <Modal show={show} size="md" centered>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#b7dfd0' }}>
          <h3 className="modal-title">Update Raw Material Sub Category</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span>×</span>
          </Button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="text-center py-5">Loading...</div>
          ) : (
            <div className="row">
              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">
                  Raw Material Category <span className="required">*</span>
                </label>
                <Select
                  placeholder="Select Raw Material Category"
                  value={selectedCategory}
                  onChange={setSelectedCategory}
                  options={categories}
                />
              </div>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">
                  Raw Material Sub Category <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Raw Material Sub Category"
                  value={subcategoryName}
                  onChange={e => setSubcategoryName(e.target.value)}
                />
              </div>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                  rows={5}
                  className="form-control h-auto"
                  placeholder="Description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </div>
            </div>
          )}

          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
            <Button variant="secondary" size="sm" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={handleUpdate}>
              Update Raw Material Sub Category
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditRawMaterialSubCat;
